import pegasus from "../../build/global/js/00-pegasus"

window.postFilter = (categories) => {
    return {
        isLoading: false,
        selectField: null,
        currentlySelected: null,
        searchForm: null,
        searchValue: null,
        currentFilters: {
            filtering: 1,
        },
        init() {
            this.selectField = this.$refs.formContainer.querySelectorAll('select')[0];
            this.searchForm = this.$refs.searchContainer;
            this.initSelects();
            this.eventListeners();

            if(typeof categories !== 'undefined' && categories !== null){
                this.currentFilters['categories'] = categories;
            }

        },
        initSelects() {
            pegasus.selectField(this.selectField, {
                openOnHover: false,
                itemsToShow: 5,
                classNames: {
                    outerWrapper:   '',
                    selector:       'flex justify-between w-full cursor-pointer body-small transition duration-300 border border-greyscale-white-04 text-left py-2.5 px-5 rounded-[50px] focus:outline-none',
                    selectorOpen:   'rounded-b-none rounded-[20px] border-b-0 bg-greyscale-white-01',
                    selectionList:  'w-full overflow-hidden bg-greyscale-white-01 border border-greyscale-white-04 border-t-0 rounded-b-[30px] px-3',
                    listItem:       'text-greyscale-white-06 body-small font-medium select-none relative py-3 border-t border-dashed border-greyscale-white-04 transition duration-300 hover:bg-greyscale-white-04 focus:bg-greyscale-white-04',
                    listItemFocus:  'bg-blue-100 text-black',
                }
            });
        },
        eventListeners(){

            // this.selectField.addEventListener('change', e => {
            //     if(e.currentTarget.value !== 'all'){
            //         this.currentFilters[e.currentTarget.getAttribute('name')] = e.currentTarget.value;
            //     } else {
            //         delete this.currentFilters[e.currentTarget.getAttribute('name')];
            //     }
                
            //     this.fetchContent(e.currentTarget);
            // });
       
            this.searchForm.addEventListener('submit', e => {
                e.preventDefault();
                if(this.$refs.searchField.value.length){
                    this.currentFilters[this.$refs.searchField.getAttribute('name')] = this.$refs.searchField.value;
                    this.searchValue = this.$refs.searchField.value;

                    this.fetchContent();
                } else {
                    this.clearSearch();
                }
                
                
            })
        },
        fetchContent(){
            const elements = ['data-pegasus-filterable="post_filter_results"']; 
            if(Object.keys(this.currentFilters).length === 1){
                this.isLoading = true;
                window.location.href = window.location.href;
            } else {
                this.isLoading = true;
                pegasus.ajaxContent(this.buildUrl(), elements, {}, () => {
                    this.removeOtherPostGrids();
                    this.isLoading = false;
                });
               
            }
           
        },
        buildUrl(){
            let url = window.location.href+'?';
            let i = 1
            for (const [key, value] of Object.entries(this.currentFilters)) {
                url += `${key}=${value}`
                if(i < Object.keys(this.currentFilters).length){
                    url+='&'
                }
                i++
            }

            return url;
        },
        removeOtherPostGrids(){
            const allPostGrids = document.querySelectorAll('.Post__Grid-Blog');

            allPostGrids.forEach(elem => {
                const section = elem.parentElement.closest('section');
                if(elem.parentElement.classList.contains('container')){
                    if(typeof elem.previousElementSibling !== "undefined" && elem.previousElementSibling !== null){
                        if(typeof elem.previousElementSibling.classList !== "undefined"){
                            if(!elem.previousElementSibling.classList.contains('Post__Filter')){
                                section.remove();
                            } else {
                                elem.remove();
                            }
                        }
                    } else {
                        section.remove();
                    }
                    
                }
            })
        },
        clearSearch(){
            this.searchValue = null;
            delete this.currentFilters[this.$refs.searchField.getAttribute('name')];
            this.$refs.searchField.value = '';

            window.location.href = window.location.href;
            // this.fetchContent();
        }
    }
    
}